// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"BenefitCreate_subTitle__H-dH2","rowSpace":"BenefitCreate_rowSpace__1Nd-1"};